export const SITE_SHARING_AUDIENCE = {
	ANYONE: 'ANYONE',
	ORGANIZATION: 'ORGANIZATION',
} as const;

export const SITE_SHARING_CONFIG_URL = '/rest/polaris/views/sharing/config';
